namespace Areas {
    "use strict";

    declare var settings: any;
    const saveUrl = "/Requests/Save";
    const reportUrl = "/Home/Index/";
    const mergeExport = "/DocumentExport/";
    const merge = "/Merge/Document/";
    const mergeSection = "/Merge/Section/";
    const editMergeSection = "/Section/Index/";

    //example of a button that fires reportFromForm OnClick
    //export function reportFromForm() {
    //    var form = $('#ProjectInfoUpdateForm').dxForm('instance');

    //    Areas.gotoReport(
    //        "ProjectInitiationReport",
    //        () => { return form.option("ProjectInfoId"); },
    //        () => { return form.option("UserId") }
    //    );
    //}
    
    export function gotoReport(reportName: string, getParameters: () => any, getUserId: () => any) {
        var parameters = getParameters();
        var userId = getUserId();

        if (isNotEmpty(parameters) && isNotEmpty(userId)) {

            var data = JSON.stringify(
                {
                    "ReportName": reportName,
                    "Parameters": parameters,
                    "UserId": userId
                });

            requestReport(data);
        }
    }

    function userInfo(): string {
        return `/${settings.user.userId}/${settings.user.userName}`;
    }

    function requestReport(data: string) {
        const errorMessage = "Error in request - Contact IS department";

        const method = "POST";
        var content: string = "application/x-www-form-urlencoded; charset=utf-8";

        var saveReportUrl = settings.reportServer + saveUrl;

        $.ajax({
            url: saveReportUrl,
            method: method,
            contentType: content,
            crossDomain: true,
            data: data,
            success: (response) => {
                if (response.errormsg) {
                    DevExpress.ui.notify(response.errormsg, "error", 2000);
                } else {
                    let messageType: string = "success";

                    DevExpress.ui.notify(response.msg, messageType, 2000);
                    openReport(response.id);
                }
            },
            error: () => {
                DevExpress.ui.notify(errorMessage, "error", 2000);
            }
        });
    }

    function openReport(id: any) {
        const url = settings.reportServer + reportUrl + id;
        window.open(url);
    }

}
